"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_SERIALIZER_OPTIONS = void 0;
exports.CLASS_SERIALIZER_OPTIONS = 'class_serializer:options';
